import React, { useMemo, useState } from "react";
import { Button, Col, Container, Dropdown, Form, Modal, Row } from "react-bootstrap";
import close from "Assets/images/cross_icon.png"
// css
import styles from "./StaffClientsModal.module.scss";
import { CloseIcon } from "Assets/icons";
import { PdfPublishForm, PdfPublishFormClassroom } from "components/Common/Common";
import { useShareEvaluationMutation } from "store/services/clients/apprentice";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { successMessageToast, userFullName } from "helpers/common";

const ChatterSendMailPop = ({ show, setShow, attendanceEntry }) => {
    const { programId, peerId, evaluationBy, sessionDate, programMember } = attendanceEntry ? attendanceEntry : {}

    const handlePopup = () => setShow(false)

    const [shareEvaluation, { isLoading: shareEvaluationLoading }] = useShareEvaluationMutation();

    const sendEvaluationReport = async (programId, peerId, therapistHead, sessionDate) => {
        try {
            const payload = {
                programId,
                peerId,
                therapistHead,
                sessionDate
            }

            let result = await shareEvaluation(payload).unwrap();
            successMessageToast(result?.data?.message || "Evaluation report sent successfully");
            handlePopup()
        } catch (err) {
            console.error("Error sharing evaluation", err);
        }
    }
    
    return (
        <>
            <Modal
                show={show}
                className={`${styles.AddNewGoalPop} modal-v2  AddNewGoalPop`}
                onHide={handlePopup}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            // style={{maxWidth: "377px"}}
            >
                <Modal.Body className={`${styles.modalBody} position-relative rounded`}>
                    {shareEvaluationLoading && <LoadingOverlay />}
                    <div className="reports-v2">
                        <div className="section-title d-flex align-items-center justify-content-end border-bottom-0 m-0" style={{ borderColor: "#315D99" }}>
                            {/* <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99" }}>{"SUBMIT & EXPORT"}</h6> */}
                            <img onClick={handlePopup} width={16} height={16} src={close} alt="close" style={{ cursor: "pointer" }} />
                        </div>
                        <div className="section-title d-flex align-items-center justify-content-between" style={{ borderColor: "#315D99" }}>
                            <h6 className="mb-0 section-title border-bottom-0" style={{ color: "#315D99", padding: 0 }}>{"EMAIL TO"}</h6>
                        </div>

                        <div
                            className="proxima-regular"
                            style={{
                                // margin: "20px auto",
                                // padding: "20px",
                                // border: "1px solid #ddd",
                                borderRadius: "6px",
                                background: "#fff",
                                position: "relative"
                            }}
                        >
                            <div style={{ borderBottom: "1px solid #ddd", paddingBottom: "15px" }}>
                                {/* <p style={{
                                    fontSize: "14px", marginBottom: "10px", textTransform: "uppercase",
                                    borderBottom: "1px solid #315D99",
                                    fontWeight: "600",
                                    color: "#315D99",
                                  }}>Email To</p> */}

                                <div className="d-flex gap-2 mb-2">
                                    <div className="proxima-regular" style={{ fontSize: "14px", color: "#000" }}>
                                        <strong style={{ color: "#000" }}>{"Peer Mentor"}:</strong>
                                        <p className="mb-0">
                                            {userFullName(programMember)}
                                        </p>
                                        <p className="mb-0">
                                            {programMember?.email}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            {/* Done Button */}
                            <div style={{ display: "flex", justifyContent: "end", textAlign: "right", marginTop: "15px" }}>
                                <button disabled={shareEvaluationLoading} onClick={() => sendEvaluationReport(programId, peerId, evaluationBy, sessionDate)} className="d-flex align-items-center gap-2 justify-content-center discharge-screen" type='button' style={{ background: "#0d3e7d" }}>
                                    Done
                                </button>
                            </div>
                        </div >
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
};

export default ChatterSendMailPop;